import { Component, Input } from '@angular/core';
import { Loader } from '@core-lib/classes';

@Component({
    selector: 'loader-spinner',
    templateUrl: './loader-spinner.component.html',
    styles: [],
    standalone: false
})
export class LoaderSpinnerComponent {
	@Input() model: Loader = new Loader(true);
	@Input() revertStyle: boolean = false;
	@Input() loadingMessage: string;
}
